/**
 * Cross-feature domain types for the authenticated user.
 * Kept separate from `features/auth` so other features can import the shape
 * without pulling in the auth feature's barrel.
 */

export type Role =
  | 'admin'
  /** Q-commerce warehouse / WMS operator (not global catalog). */
  | 'warehouse_manager'
  | 'accountant'
  | 'finance_admin';

export const ROLES = [
  'admin',
  'warehouse_manager',
  'accountant',
  'finance_admin',
] as const satisfies readonly Role[];

export interface User {
  id: string;
  username: string;
  name: string;
  role: Role;
  /**
   * Store scope for Managers (and optionally filtered views for Accountants).
   * Admins see all stores regardless — the array may be empty.
   */
  storeIds: string[];
}

/** The shape the BE returns from `/auth/login` and `/auth/refresh`. */
export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}
